import { onSelect, onSelectAll } from '../utils/dom'

export const SEL_SHADOW_BOX = onSelect('.bl-benefits-template--icon.icon--shadow-box')
export const SEL_BOX = onSelect('.bl-benefits-template--icon.icon--box')
export const SEL_LEVER = onSelect('.bl-benefits-template--icon.icon--lever')
export const SEL_BTN_ON = onSelect('.bl-benefits-template--icon.icon--on')
export const SEL_BTN_OFF = onSelect('.bl-benefits-template--icon.icon--off')
export const SEL_SHADOW_BELT = onSelect('.bl-benefits-template--icon.icon--shadow-belt')
export const SEL_BELT = onSelect('.bl-benefits-template--icon.icon--belt')
export const SEL_SHADOW_HOTEL = onSelect('.bl-benefits-template--icon.icon--shadow-hotel')
export const SEL_HOTEL = onSelect('.bl-benefits-template--icon.icon--hotel')
export const SEL_TITLE_1 = onSelectAll('[data-js="title"].bl-benefits-items--box-title')
export const SEL_TITLE_2 = onSelectAll('[data-js="title"].item--550861')
export const SEL_TITLE_3 = onSelectAll('[data-js="title"].item--550862')
export const SEL_TITLE_4 = onSelectAll('[data-js="title"].item--550863')
export const SEL_TITLE_5 = onSelectAll('[data-js="title"].item--550864')
export const SEL_TITLE_6 = onSelectAll('[data-js="title"].item--550865')
export const SEL_TITLE_7 = onSelectAll('[data-js="title"].item--550866')
export const SEL_TITLE_8 = onSelectAll('[data-js="title"].item--550867')
export const SEL_TITLE_9 = onSelectAll('[data-js="title"].item--550868')
export const SEL_TITLE_10 = onSelectAll('[data-js="title"].item--551178')
export const SEL_TITLE_11 = onSelectAll('[data-js="title"].item--551179')
export const SEL_MEETING_GROUP_1 = onSelect('.bl-benefits-template--figure.figure--550861-0')
export const SEL_MEETING_GROUP_2 = onSelect('.bl-benefits-template--figure.figure--550863-0')
export const SEL_MEETING_GROUP_3 = onSelect('.bl-benefits-template--figure.figure--550866-0')
export const SEL_COUPLE_WEDDINGS_1 = onSelect('.bl-benefits-template--figure.figure--550862-0')
export const SEL_COUPLE_WEDDINGS_2 = onSelect('.bl-benefits-template--figure.figure--550865-0')
export const SEL_COUPLE_WEDDINGS_3 = onSelect('.bl-benefits-template--figure.figure--550867-0')
export const SEL_CAKE_1 = onSelect('.bl-benefits-template--figure.figure--550862-1')
export const SEL_CAKE_2 = onSelect('.bl-benefits-template--figure.figure--550865-1')
export const SEL_CAKE_3 = onSelect('.bl-benefits-template--figure.figure--550867-1')
